import React from 'react'
import Helmet from "../components/Helmet/Helmet";
import CommonSection from "../components/UI/CommonSection";

const NotFound = () => {
  return (
    <Helmet title="Other Services">
      <CommonSection title="Resources" />
    <div className='notfound'>
      <h1 className="mb-5 text-center "></h1>
    </div>
    </Helmet>
  )
}

export default NotFound
